<template>
    <div>
        <table class="table table-sm">
            <tr>
                <td><span class="label label-dot label-default"/> Total</td>
                <td>{{ stats.total }}</td>
                <td></td>
            </tr>
            <tr>
                <td><span class="label label-dot label-danger"/> Skipped</td>
                <td class="w-25">{{ stats.skipped }}</td>
                <td class="w-25">{{ ratios.skipped }}%</td>
            </tr>
            <tr>
                <td><span class="label label-dot label-success"/> New</td>
                <td>{{ stats.new }}</td>
                <td>{{ ratios.new }}%</td>
            </tr>
            <tr>
                <td><span class="label label-dot label-info"/> Updated</td>
                <td>{{ stats.updated }}</td>
                <td>{{ ratios.updated }}%</td>
            </tr>
        </table>
        <div class="progress h-2em">
            <div class="progress-bar bg-danger"
                 :class="{'progress-bar-striped progress-bar-animated': loading}"
                 role="progressbar"
                 :style="`width: ${ratios.skipped}%`"
            />
            <div class="progress-bar bg-success"
                 :class="{'progress-bar-striped progress-bar-animated': loading}"
                 role="progressbar"
                 :style="`width: ${ratios.new}%`"
            />
            <div class="progress-bar bg-info"
                 :class="{'progress-bar-striped progress-bar-animated': loading}"
                 role="progressbar"
                 :style="`width: ${ratios.updated}%`"
            />
        </div>

        <div class="mt-3 text-muted">
            Sie können dieses Fenster jetzt schließen.
        </div>
    </div>
</template>

<script>
export default {
    props: {
        firebaseUid: String,
    },

    data() {
        return {
            loading: true,
            stats: {
                total: 0,
                read: 0,
                skipped: 0,
                new: 0,
                updated: 0,
            },
            ratios: {
                skipped: 0,
                new: 0,
                updated: 0,
            },
        }
    },

    mounted() {
        window.Echo.private('users.' + this.firebaseUid).
            listen('.brand-product-import', (data) => {
                this.stats = data

                this.ratios = {
                    skipped: this.ratio(data.skipped),
                    new: this.ratio(data.new),
                    updated: this.ratio(data.updated),
                }

                if (data.total === data.read) {
                    this.loading = false
                    this.$emit('hideButton')
                }
            })
    },

    methods: {
        ratio(n) {
            if (this.stats.total === 0) {
                return 0
            }

            return (n * 100 / this.stats.total).toFixed(1)
        },
    },
}
</script>
